import { Icon } from '@zapier/design-system';
import React from 'react';
import { Link, Button } from 'react-aria-components';

const root = "_root_b66h0_1";
const styles = {
	root: root
};

function isLinkProps(props) {
  return typeof props.href === "string";
}
const StatusChip = (props) => {
  const { href, hrefLang, onPress, size, target, variant } = props;
  const getIconProps = () => {
    const iconSize = size === "medium" ? "var(--zds-size-20)" : "var(--zds-size-16)";
    if (variant === "warning") {
      return {
        name: "alertCircleColor",
        color: void 0,
        size: iconSize
      };
    } else if (variant === "error") {
      return {
        name: "formXCircle",
        color: "StatusErrorStronger",
        size: iconSize
      };
    } else {
      return {
        name: "formCheckCircle",
        color: "StatusSuccessStronger",
        size: iconSize
      };
    }
  };
  if (isLinkProps(props)) {
    return React.createElement(Link, { className: styles.root, "data-size": size, "data-variant": true, "data-zds": true, href, hrefLang, onPress, target }, (linkRenderProps) => React.createElement(
      React.Fragment,
      null,
      React.createElement(Icon, Object.assign({}, getIconProps())),
      typeof props.children === "function" ? props.children(linkRenderProps) : props.children
    ));
  }
  return React.createElement(Button, { className: styles.root, "data-size": size, "data-variant": variant, "data-zds": true, onPress }, (buttonRenderProps) => React.createElement(
    React.Fragment,
    null,
    React.createElement(Icon, Object.assign({}, getIconProps())),
    typeof props.children === "function" ? props.children(buttonRenderProps) : props.children
  ));
};

export { StatusChip };
//# sourceMappingURL=StatusChip.es.js.map
